export * from './use-swr';
import { default as useSWR } from './use-swr';
export { useSWRInfinite } from './use-swr-infinite';
export { cache } from './config';
export default useSWR;
